import CommentsApi from '../api/CommentsApi';
import CommentsConstants from '../constants/CommentsConstants';

function addComment({ metadataId, comment, postSuccess }) {
  return {
    metadataId,
    postSuccess,
    types: [
      CommentsConstants.ADD_COMMENT_REQUEST,
      CommentsConstants.ADD_COMMENT_SUCCESS,
      CommentsConstants.ADD_COMMENT_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => CommentsApi.addComment({
      metadataId,
      comment,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function updateComment({ metadataId, commentId, comment, postSuccess }) {
  return {
    metadataId,
    commentId,
    postSuccess,
    types: [
      CommentsConstants.UPDATE_COMMENT_REQUEST,
      CommentsConstants.UPDATE_COMMENT_SUCCESS,
      CommentsConstants.UPDATE_COMMENT_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => CommentsApi.updateComment({
      commentId,
      comment,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeComment({ metadataId, commentId, postSuccess }) {
  return {
    metadataId,
    commentId,
    postSuccess,
    types: [
      CommentsConstants.REMOVE_COMMENT_REQUEST,
      CommentsConstants.REMOVE_COMMENT_SUCCESS,
      CommentsConstants.REMOVE_COMMENT_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => CommentsApi.removeComment({
      commentId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.comments.${commentId}`]
    })
  };
}

export default {
  addComment,
  updateComment,
  removeComment
};



// WEBPACK FOOTER //
// ./app/actions/CommentsActions.js